import { useCallback, useMemo, useState } from "react";
import { useApolloClient } from "@apollo/client";

import { useAppDispatch, useAppSelector } from "../../../Store";

import { PanelBasicQueryInfoInput } from "../FeedDataCalls/GQLCalls/getFeedComponentsCall";

import { gqlActions } from "../gqlData_Reducer";
import Graph_QL, { GqlHook_Returns, StateDataObject } from "..";
import { noop } from "lodash";
import { filterByConnection } from "../filterByConnection";

import { MilestoneItem } from "./MilestoneDataSlices/milestoneSlice";
import { MilestonesResponse, GET_MILESTONES } from "./GQLCalls/getMilestonesCall";
import { CREATE_MILESTONES, CreateMilestonesResponse } from "./GQLCalls/createMilestonesCall";
import { MARK_MILESTONE_AS_DELETED, MarkMilestonesAsDeletedResponse } from "./GQLCalls/deleteMilestoneCall";


export const useMilestones = (connection: Graph_QL.GQLCons): GqlHook_Returns<MilestoneItem, PanelBasicQueryInfoInput>  => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();
  const [, setCursorId] = useState(-1);

  const milestonesState = useAppSelector(({graphQlData:{domain}}) => domain.milestones);
  const {fullState} = useMemo(() => {
    const state = filterByConnection(milestonesState, Graph_QL.ToArr(connection)) as Record<string, MilestoneItem>
    return Object.entries(state).reduce((accumulator, [key, data]) => {
      if (data.data) {
        const value = {...data.data, domain:key}; 
        accumulator.data = accumulator.data.concat(value)
      }
      return accumulator
    },{fullState: state, data: []} as StateDataObject<MilestoneItem>)
  },[connection, milestonesState]);

  const getMilestoneInfo = useCallback(async (input: PanelBasicQueryInfoInput, specific?: Graph_QL.GQLCons) => {
    const specificConnection = specific ? specific : connection;
    try {
      client.query<MilestonesResponse>({query: GET_MILESTONES, variables: {...specificConnection.connection, input: {ids: input?.ids, offset: input?.offset, fetchAmount: input?.fetchAmount}}})
        .then((e) => {
          if (e && e.data) {
            dispatch({type: String(gqlActions.domain.milestones.maintained), payload: {con: specificConnection.connection, data: e.data.milestone.info}});
            setCursorId(e.data.milestone.info.at(-1)?.milestone_id ?? -1)
          }
        }).catch((error) => {console.log(error);})
    } catch (error) {
        console.log(error);
      }
    },[client, connection, dispatch])

  const maintainEntries = async (changedData?: Partial<MilestoneItem>) => {
    const newMilestones = changedData?.data?.filter((milestone) => milestone.milestone_id === undefined).map((milestone) => milestone.name);
    const milestonesForDeletion = changedData?.data?.filter((milestone) => milestone.deleted).map((milestone) => milestone.milestone_id);
    console.log(milestonesForDeletion, changedData);
    if (newMilestones?.length) {
        try {
          client.mutate<CreateMilestonesResponse>({mutation: CREATE_MILESTONES, variables: {...connection.connection, names: newMilestones}})
            .then((e) => {
              if (e && e.data) {
                dispatch({type: String(gqlActions.domain.milestones.maintained), payload: {con: connection.connection, data: e.data.milestone.create}});
              }
            })
      } catch (error) {
        console.log(error);
      }
    }
    if (milestonesForDeletion?.length) {
      try {
        client.mutate<MarkMilestonesAsDeletedResponse>({mutation: MARK_MILESTONE_AS_DELETED, variables: {...connection.connection, ids: milestonesForDeletion}})
          .then((response) => {
            if (response && response.data && response.data.milestone.markAsDeleted.success) {
              dispatch({type: String(gqlActions.domain.milestones.maintained), payload: {con: connection.connection, data: response.data.milestone.markAsDeleted.updatedValues}})
            }
          })
      } catch (error) {
        console.log(error);
      }
    }
  }

  return {call: getMilestoneInfo, fetchMore: noop, deleteEntries: noop, data: fullState, maintainEntries}
} 

